// Leaving a page with unsaved work, for the exits the browser does NOT ask
// about.
//
// `beforeunload` covers reload, tab close and typing a new address. It does
// nothing for the two exits this app actually loses work through: a sidebar
// link (react-router swaps the tree, the document never unloads) and the
// language switcher (App.js keys <Routes> on the language, so the whole routed
// tree remounts).
//
// Rather than have every such control learn which pages are dirty, the dirty
// page announces itself the standard way — a `beforeunload` listener that
// calls preventDefault — and these two helpers ask the same question by firing
// a cancelable event of that name. A page already guarding against reload is
// then guarded here for free.

// Register while `isDirty`. Returns the cleanup effect callback shape.
export const guardUnsavedWork = (isDirty) => {
  if (!isDirty) return undefined;
  const onBeforeUnload = (e) => {
    e.preventDefault();
    // Legacy browsers need a returnValue to show their own prompt; modern ones
    // show a fixed message and ignore whatever is set here.
    e.returnValue = "";
  };
  window.addEventListener("beforeunload", onBeforeUnload);
  return () => window.removeEventListener("beforeunload", onBeforeUnload);
};

// True when it is safe to leave: nothing is dirty, or the person confirmed.
// `confirmMessage` is already-translated text.
export const confirmLeaveUnsavedWork = (confirmMessage) => {
  const probe = new Event("beforeunload", { cancelable: true });
  window.dispatchEvent(probe);
  if (!probe.defaultPrevented) return true;
  return window.confirm(confirmMessage);
};
